import { render, staticRenderFns } from "./PointAndSaturationForm.vue?vue&type=template&id=3a39cd44"
import script from "./PointAndSaturationForm.vue?vue&type=script&lang=js"
export * from "./PointAndSaturationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports